import { render, staticRenderFns } from "./gBottom.vue?vue&type=template&id=8dca580c&scoped=true"
import script from "./gBottom.vue?vue&type=script&lang=js"
export * from "./gBottom.vue?vue&type=script&lang=js"
import style0 from "./gBottom.vue?vue&type=style&index=0&id=8dca580c&prod&lang=scss&scoped=true"
import style1 from "./gBottom.vue?vue&type=style&index=1&id=8dca580c&prod&lang=scss"
import style2 from "./gBottom.vue?vue&type=style&index=2&id=8dca580c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dca580c",
  null
  
)

export default component.exports